import { render } from "./index.vue?vue&type=template&id=3b034f8b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3b034f8b&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=3b034f8b&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b034f8b"]])

export default __exports__